import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { findForeignerPersonalPassport, findForeignerPersonals, findHistoryForeignerPersonal } from "services/ForeignerPersonalService";
import { findNationalities } from "services/NationalityService";
import { X_TOTAL_COUNT } from "utils/constants";
import { dateFormat1, dateFormat2, formatDate, range2 } from "utils/date";
import { removeVietnameseTones } from "utils/functions";
import { handleError } from "utils/handleError";
import { ForeignerPersonalContext } from "./ForeignerPersonalContext";
import { ForeignerPersonalEditor } from "./ForeignerPersonalEditor";
import { ForeignerPersonalHistory } from "./ForeignerPersonalHistory";
export const ForeignerPersonalList = () => {
    const avatar = process.env.PUBLIC_URL + "/assets/layout/images/avatar.png";
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["foreigner-personal", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const foreignerPersonalContext = useContext(ForeignerPersonalContext);
    const { foreignerPersonals, setForeignerPersonals, foreignerPersonal, setForeignerPersonal, foreignerPersonalDialog, setForeignerPersonalDialog, foreignerPersonalHistories, setForeignerPersonalHistories, foreignerPersonalHistoryDialog, setForeignerPersonalHistoryDialog } =
        foreignerPersonalContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [checkLoad, setCheckLoad] = useState(false);
    const [selectedForeignerPersonal, setSelectForeignerPersonal] = useState(null);
    const [submit, setSubmit] = useState(false);
    const [passport, setPassport] = useState(null);
    const [nationalities, setNationalities] = useState([]);

    const now = new Date();

    const beforeNow = new Date(new Date().setDate(new Date().getDate() - range2));

    const [formatDateVal, setFormatDateVal] = useState(dateFormat1);

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: "", matchMode: "contains" },
            passportNo: { value: "", matchMode: "contains" },
            fullName: { value: "", matchMode: "contains" },
            birthDay: { value: null, matchMode: "equals" },
            email: { value: null, matchMode: "equals" },
            phoneNumber: { value: null, matchMode: "equals" },
            nationalityId: { value: null, matchMode: "equals" },
            fromDate: { value: null, matchMode: "equals" },
            toDate: { value: null, matchMode: "equals" },
        },
    });

    useEffect(() => {
        getNationalities();
    }, []);

    const getNationalities = () => {
        findNationalities(headers, { first: 0, rows: 10000, page: 0 }).then((res) => {
            setNationalities(
                res.data.map((e) => {
                    return { label: e.name, value: e.id };
                })
            );
        });
    };

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    useEffect(() => {
        setForeignerPersonalHistories([]);
        if (selectedForeignerPersonal?.id) {
            findHistoryForeignerPersonal(headers, selectedForeignerPersonal.id).then((res) => {
                const dataFinals = [];
                res.data.forEach((e) => {
                    if (e.noiDungThayDoi) {
                        const data = JSON.parse(e.noiDungThayDoi);
                        Object.entries(data).forEach((x, y) => {
                            const values = x[1]?.split("->");
                            dataFinals.push({
                                ...e,
                                field: x[0],
                                valueBefore: values[0],
                                valueAfter: values[1],
                            });
                        });
                    } else {
                        dataFinals.push({ ...e });
                    }
                });
                dataFinals.forEach((e, i) => {
                    e.stt = i + 1;
                });
                setForeignerPersonalHistories(dataFinals);
            });
        }
    }, [selectedForeignerPersonal?.id]);

    useEffect(() => {
        setPassport(null);
        if (selectedForeignerPersonal?.idNumber) {
            findForeignerPersonalPassport(headers, selectedForeignerPersonal.idNumber, selectedForeignerPersonal.passport).then((res) => {
                setPassport(res.data.portrait);
                setSelectForeignerPersonal({
                    ...selectedForeignerPersonal,
                    dateOfIssue: res.data?.dateOfIssue,
                    dateOfExpiry: res.data?.dateOfExpiry,
                    authority: res.data?.authority,
                    type: res.data?.type,
                    enabled: res.data?.enabled,
                    countryCode: res.data?.countryCode,
                });
            });
        }
    }, [selectedForeignerPersonal?.idNumber]);

    const loadLazyData = () => {
        setLoading(true);
        setPassport(null);
        setForeignerPersonal(null);
        setSelectForeignerPersonal(null);
        setForeignerPersonalHistories([]);

        findForeignerPersonals(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                });
                if (dataRes.length > 0) {
                    setSelectForeignerPersonal(dataRes[0]);
                }
                setForeignerPersonals(dataRes);
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => setLoading(false));
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOption = (
        <>
            <div className="grid">
                {/* số định danh */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="idNumber"
                        >
                            {t("foreigner-personal.idNumber")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="idNumber"
                                name="idNumber"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setSubmit(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            idNumber: {
                                                ...lazyParams.filters.idNumber,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* số hộ chiếu */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="passportNo"
                        >
                            {t("foreigner-personal.passportNo")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="passportNo"
                                name="passportNo"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setSubmit(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            passportNo: {
                                                ...lazyParams.filters.passportNo,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* họ vào tên */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="fullName"
                        >
                            {t("foreigner-personal.fullName")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="fullName"
                                name="fullName"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setSubmit(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            fullName: {
                                                ...lazyParams.filters.fullName,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* ngày sinh */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "80px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="birthDay"
                        >
                            {t("foreigner-personal.birthDay")}
                        </label>
                        <div className="col">
                            <Calendar
                                style={{ width: "100%" }}
                                value={lazyParams.filters.birthDay.value}
                                onChange={(e) => {
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            birthDay: {
                                                ...lazyParams.filters.birthDay,
                                                value: e.value,
                                            },
                                        },
                                    });
                                }}
                                onBlur={() => {
                                    setFormatDateVal(dateFormat1);
                                }}
                                onFocus={() => {
                                    setFormatDateVal(dateFormat2);
                                }}
                                name="birthDay"
                                id="birthDay"
                                dateFormat={formatDateVal}
                            ></Calendar>
                            {/* <InputText
                            style={{
                                width: "100%",
                            }}
                            type="date"
                            id="birthDay"
                            name="birthDay"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setSubmit(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        birthDay: {
                                            ...lazyParams.filters.birthDay,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText> */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid">
                {/* dia chi email */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="email"
                        >
                            {t("foreigner-personal.email")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                type="email"
                                id="email"
                                name="email"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setSubmit(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            email: {
                                                ...lazyParams.filters.email,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>
                {/* số đt */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="phoneNumber"
                        >
                            {t("foreigner-personal.phoneNumber")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="phoneNumber"
                                name="phoneNumber"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setSubmit(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            phoneNumber: {
                                                ...lazyParams.filters.phoneNumber,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>
                {/* quốc tịch */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0.75rem 0px 0px",
                            }}
                            htmlFor="nationalityId"
                        >
                            {t("foreigner-personal.nationalityId")}
                        </label>
                        <Dropdown
                            name="nationalityId"
                            className="col"
                            style={{ width: "100%", margin: "5px 0px 0px 0px" }}
                            id="nationalityId"
                            filter={true}
                            showClear={true}
                            showFilterClear={true}
                            filterInputAutoFocus={true}
                            emptyFilterMessage={"Không tìm thấy dữ liệu"}
                            emptyMessage={"KHông có dữ liệu"}
                            value={lazyParams.filters.nationalityId.value}
                            options={nationalities}
                            filterOption={(input, option) => removeVietnameseTones(option.children)?.toLowerCase().indexOf(removeVietnameseTones(input)?.toLowerCase()) >= 0}
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        nationalityId: {
                                            ...lazyParams.filters.nationalityId,
                                            value: e.value,
                                        },
                                    },
                                });
                            }}
                            tooltip={nationalities.find((e) => e.value === lazyParams.filters.nationalityId.value)?.label}
                            tooltipOptions={{ position: "top" }}
                        ></Dropdown>
                    </div>
                </div>

                <div className="col-12 md:col-3 text-right">
                    <div className="grid custom-form">
                        <div className="col-12">
                            <label
                                style={{
                                    // width: "130px",
                                    // justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                            >
                                {" "}
                            </label>
                        </div>
                        <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                            <Button
                                label={t("search", { ns: "common" })}
                                icon="pi pi-search"
                                onClick={(e) => {
                                    setSubmit(true);
                                    if (lazyParams.filters.idNumber.value || lazyParams.filters.passportNo.value || lazyParams.filters.email.value || lazyParams.filters.phoneNumber.value || (lazyParams.filters.birthDay.value && lazyParams.filters.fullName.value)) {
                                        setCheckLoad(true);
                                        setLazyParams({
                                            ...lazyParams,
                                            first: 0,
                                            page: 0,
                                        });
                                    } else {
                                        toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("foreigner-personal.required2"), life: 3000 });
                                    }
                                    // if (
                                    //     !lazyParams.filters.birthDay.value &&
                                    //     !lazyParams.filters.email.value &&
                                    //     !lazyParams.filters.fullName.value &&
                                    //     !lazyParams.filters.idNumber.value &&
                                    //     !lazyParams.filters.nationalityId.value &&
                                    //     !lazyParams.filters.passportNo.value &&
                                    //     !lazyParams.filters.phoneNumber.value
                                    // ) {
                                    //     toast.current.show({ severity: "error", summary: t("error", { ns: "common" }), detail: t("foreigner-personal.required"), life: 3000 });
                                    // } else if (!!lazyParams.filters.idNumber.value || !!lazyParams.filters.passportNo.value || !!lazyParams.filters.email.value || !!lazyParams.filters.phoneNumber.value || (!!lazyParams.filters.birthDay.value && !!lazyParams.filters.fullName.value)) {
                                    //     setCheckLoad(true);
                                    //     setLazyParams({
                                    //         ...lazyParams,
                                    //         first: 0,
                                    //         page: 0,
                                    //     });
                                    // } else {
                                    //     toast.current.show({ severity: "error", summary: t("error", { ns: "common" }), detail: t("foreigner-personal.required1"), life: 3000 });
                                    // }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const showDialog = (rowData) => {
        setForeignerPersonal(rowData);
        setForeignerPersonalDialog(true);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center actions">
                <Button icon="pi pi-eye" className="p-button-rounded p-button mr-2" tooltip={t("view", { ns: "common" })} onClick={(e) => showDialog(rowData)} />
            </div>
        );
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("foreigner-personal.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("foreigner-personal.list")}>
                                <Toast ref={toast} />

                                <DataTable
                                    ref={dt}
                                    value={foreignerPersonals}
                                    dataKey="stt"
                                    className="datatable-responsive p-datatable-sm"
                                    selectionMode="single"
                                    selection={selectedForeignerPersonal}
                                    onSelectionChange={(e) => {
                                        setSelectForeignerPersonal(e.value);
                                    }}
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    onSort={onSort}
                                    sortField={lazyParams.sortField}
                                    sortOrder={lazyParams.sortOrder}
                                    onFilter={onFilter}
                                    filters={lazyParams.filters}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorTemplate}
                                    emptyMessage="Không có dữ liệu"
                                    scrollable
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    <Column field="idNumber" header={t("foreigner-personal.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="passport" header={t("foreigner-personal.passport")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="fullName" header={t("foreigner-personal.fullName")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="birthDate" header={t("foreigner-personal.birthDate")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="gender" header={t("foreigner-personal.gender")} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="nationality" header={t("foreigner-personal.nationality")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="phoneNumber" header={t("foreigner-personal.phoneNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="email" header={t("foreigner-personal.email")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="accLevel" header={t("foreigner-personal.accLevel")} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="address" header={t("foreigner-personal.address")} style={{ minWidth: "250px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column body={actionBodyTemplate} style={{ maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                </DataTable>
                            </BlockDetail>
                        </div>
                        {selectedForeignerPersonal && (
                            <>
                                <div className="col-12 text-center">
                                    <Button className="p-button" label={t("foreigner-personal.historyChangeInfoPerson")} onClick={(e) => setForeignerPersonalHistoryDialog(true)} />
                                </div>

                                <div className="col-12">
                                    <BlockDetail title={t("foreigner-personal.titleDetail")}>
                                        <div className="grid">
                                            <div className="col-fixed" style={{ width: "200px" }}>
                                                <img src={passport ? `data:image/jpeg;base64,${passport}` : avatar} width="100%" height={"300px"} alt=""></img>
                                            </div>

                                            <div className="col">
                                                <div className="grid">
                                                    <div className="col-12">
                                                        <div className="grid">
                                                            {/* số đinh danh */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="idNumber" className="custom-form">
                                                                    {t("foreigner-personal.idNumber")}
                                                                </label>
                                                                <InputText id="idNumber" value={selectedForeignerPersonal?.idNumber} readOnly className="custom-form" />
                                                            </div>

                                                            {/* số hộ chiếu */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="passport" className="custom-form">
                                                                    {t("foreigner-personal.passport")}
                                                                </label>
                                                                <InputText id="passport" value={selectedForeignerPersonal?.passport} readOnly className="custom-form" />
                                                            </div>

                                                            {/* họ và tên*/}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="fullName" className="custom-form">
                                                                    {t("foreigner-personal.fullName")}
                                                                </label>
                                                                <InputText id="fullName" value={selectedForeignerPersonal?.fullName} readOnly className="custom-form" />
                                                            </div>
                                                        </div>

                                                        <div className="grid">
                                                            {/* ngày sinh */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="birthDate" className="custom-form">
                                                                    {t("foreigner-personal.birthDate")}
                                                                </label>
                                                                <InputText id="birthDate" value={selectedForeignerPersonal?.birthDate} readOnly className="custom-form" />
                                                            </div>

                                                            {/* giới tính */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="gender" className="custom-form">
                                                                    {t("foreigner-personal.gender")}
                                                                </label>
                                                                <InputText id="gender" value={selectedForeignerPersonal?.gender} readOnly className="custom-form" />
                                                            </div>
                                                            {/* ngày cấp */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="ngayCap" className="custom-form">
                                                                    {t("foreigner-personal.ngayCap")}
                                                                </label>
                                                                <InputText id="ngayCap" value={selectedForeignerPersonal?.dateOfIssue?.substr(0, 10)} readOnly className="custom-form" />
                                                            </div>
                                                        </div>

                                                        <div className="grid">
                                                            {/* ngày hết hạn */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="deadDate" className="custom-form">
                                                                    {t("foreigner-personal.deadDate")}
                                                                </label>
                                                                <InputText id="deadDate" value={selectedForeignerPersonal?.dateOfExpiry?.substr(0, 10)} readOnly className="custom-form" />
                                                            </div>

                                                            {/* nơi cấp */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="noiCap" className="custom-form">
                                                                    {t("foreigner-personal.noiCap")}
                                                                </label>
                                                                <InputText id="noiCap" value={selectedForeignerPersonal?.authority} readOnly className="custom-form" />
                                                            </div>

                                                            {/* loại hộ chiếu */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="loaiHoChieu" className="custom-form">
                                                                    {t("foreigner-personal.loaiHoChieu")}
                                                                </label>
                                                                <InputText id="loaiHoChieu" value={selectedForeignerPersonal?.type} readOnly className="custom-form" />
                                                            </div>
                                                        </div>

                                                        <div className="grid">
                                                            {/* quốc tịch */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="nationality" className="custom-form">
                                                                    {t("foreigner-personal.nationality")}
                                                                </label>
                                                                <InputText id="nationality" value={selectedForeignerPersonal?.nationality} readOnly className="custom-form" />
                                                            </div>

                                                            {/* mã quốc gia */}
                                                            <div className="field col-12 md:col-4">
                                                                <label htmlFor="maQuocGia" className="custom-form">
                                                                    {t("foreigner-personal.maQuocGia")}
                                                                </label>
                                                                <InputText id="maQuocGia" value={selectedForeignerPersonal?.countryCode} readOnly className="custom-form" />
                                                            </div>

                                                            <div
                                                                className="field col-12 md:col-2"
                                                                style={{
                                                                    display: "flex",
                                                                    margin: "auto",
                                                                }}
                                                            >
                                                                <Checkbox checked={selectedForeignerPersonal.enabled === "Y"} readOnly />
                                                                <label htmlFor="hieuLuc">{t("foreigner-personal.hieuLuc")}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </BlockDetail>
                                </div>
                            </>
                        )}
                    </div>

                    <ForeignerPersonalEditor />
                    <ForeignerPersonalHistory />
                </div>
            </div>
        </div>
    );
};
